import React from "react";
import dynamic from "next/dynamic";
import ServiceSectionFirst from "./section-01";
import ServiceSectionSecond from "./section-02";
import ServiceSectionThird from "./section-03";
const ServiceSectionFourth = dynamic(() => import("./section-04"));
const ServiceSectionFifth = dynamic(() => import("./section-05"));
const ServiceSectionPackages = dynamic(() => import("./packages-section"));
const ServiceSectionSixth = dynamic(() => import("./section-06"));
import SeoComponent from "./seo";
const FaqDynamic = dynamic(() => import("../faqDynamic"));
import { useInView } from "react-intersection-observer";
//import * as fbq from "@lib/fpixel";
import generateUniqueEventID from "@lib/generateUniqueEventID";
import useMouseOver from "@hooks/useMouseOver";
import axios from "axios";
import useClientIP from "@/hooks/useClientIP";
import { v4 as uuidv4 } from 'uuid';

const Index = ({ projectsData }) => {
  const {
    section_01,
    section_02,
    section_03,
    section_04,
    section_05,
    packages_data,
    section_faqData,
    seo,
    slug,
  } = projectsData;
  const section_seo = seo;
  const [ref, inView] = useInView({
    triggerOnce: true, // This means the animation will trigger only once when it comes into view
    threshold: 0.1, // Percentage of the component's visibility, adjust as needed
  });
  const uniqueEventID = generateUniqueEventID();
  const isPixelActive = useMouseOver();
  const ipAddress = useClientIP();

  function getClickId() {
    // Check for _fbc cookie
    const fbcCookie = document.cookie
      .split('; ')
      .find(row => row.startsWith('_fbc='));
  
    if (fbcCookie) {
      console.log('Returning _fbc from cookie:', fbcCookie.split('=')[1]);
      return fbcCookie.split('=')[1];
    } else {
      console.warn('No _fbc cookie found');
    }
  
    // Generate _fbc from fbclid query parameter if _fbc cookie does not exist
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');
    if (fbclid) {
      const subdomainIndex = 1; // Adjust this based on your domain structure
      const creationTime = Math.floor(new Date().getTime() / 1000); // Use current time as creation time
      const generatedFbc = `fb.${subdomainIndex}.${creationTime}.${fbclid}`;
      console.log('Generated _fbc from fbclid:', generatedFbc);
      return generatedFbc;
    } else {
      console.warn('No fbclid query parameter found');
    }
  
    // Generate a fallback _fbc value
    const subdomainIndex = 1;
    const creationTime = Math.floor(new Date().getTime() / 1000);
    const placeholderFbclid = '0000000000000000'; // Placeholder if no fbclid is found
    const fallbackFbc = `fb.${subdomainIndex}.${creationTime}.${placeholderFbclid}`;
    console.log('Generated fallback _fbc:', fallbackFbc);
    return fallbackFbc;
  }

  function getBrowserId() {
    // Logic to get Facebook Browser ID (fbp)
    const fbpCookie = document.cookie
      .split('; ')
      .find(row => row.startsWith('_fbp='));
    return fbpCookie ? fbpCookie.split('=')[1] : undefined;
  }
  
  async function sendViewContentEvent(eventName, customData, uniqueEventID) {
    const userAgent = navigator.userAgent;
    const clickId = getClickId(); // Replace with your actual click ID logic
    const browserId = getBrowserId(); // Function to get Facebook Browser ID (fbp)
    const externalId = uuidv4(); // Replace with your actual external ID logic
    const ipaddress = ipAddress; 
    try {
      const response = await axios.post('/api/send-eventcontent', {
        eventName,
        customData,
        uniqueEventID,
        clickId,
        userAgent,
        browserId,
        externalId,
        ipAddress:ipaddress
      });
  
      console.log('ViewContent event sent successfully:', response.data);
    } catch (error) {
      console.error('Error sending ViewContent event:', error.response ? error.response.data : error.message);
    }
  }

  React.useEffect(() => {
    const sendClientSideTracking = async () => {
      if (process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_CONTROLER === "true" && isPixelActive) {
        await sendViewContentEvent('ViewContent', {
          content_type: "Service Page",
          content_name: `/services/${slug.current}`,
          currency: "PKR",
        }, uniqueEventID); // Replace 'unique-event-id' with your actual unique event ID logic
      }
    };

    sendClientSideTracking();
  }, [isPixelActive, slug.current]);

/*
  React.useEffect(() => {
    const sendClientSideTracking = () => {
      if (
        process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_CONTROLER === "true" &&
        isPixelActive
      ) {
        
        fbq.event(
          "ViewContent",
          {
            content_type: "Service Page",
            content_name: `/services/${slug.current}`,
            currency: "PKR",
          },
          uniqueEventID,
        );
      }
    };

    sendClientSideTracking();
  }, [isPixelActive]);
*/

  return (
    <div className="overflow-hidden">
      <SeoComponent data={section_seo} />

      <section className="min-h-[100vh] ">
        <ServiceSectionFirst data={section_01} />
        <ServiceSectionSecond data={section_02} />
        <ServiceSectionThird data={section_03} />
        <ServiceSectionFourth data={section_04} />
        <ServiceSectionFifth data={section_05} />

        <div ref={ref}>
          {" "}
          {inView && packages_data && (
            <ServiceSectionPackages data={packages_data} />
          )}{" "}
        </div>
        <ServiceSectionSixth />

        <section className="main_container_faq">
          <FaqDynamic data={section_faqData} />

          <style jsx global>{`
            .main_container_faq {
              position: relative;
              width: 100%;
              background: black;
              background-repeat: no-repeat;
              z-index: 20;
              top: 0;
              height: auto;
              justify-content: center;
              display: flex;
              min-height: 100%;
              padding-bottom: 4rem;
            }

            .main_container_faq::before {
              content: "";
              position: absolute;
              z-index: -2;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background:
                --background,
                no-repeat center / cover;
              opacity: 0.1;
            }
          `}</style>
        </section>
      </section>
    </div>
  );
};

export default Index;
